document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('.stat-number');

  if (!counters.length) return;

  const animateCounter = (el) => {
    const target = parseFloat(el.dataset.value);
    const suffix = el.dataset.suffix || '';
    let current = 0;

    const increment = target / 60; // duración aprox

    const update = () => {
      current += increment;
      if (current >= target) {
        el.textContent = target + suffix;
      } else {
        el.textContent = Math.floor(current) + suffix;
        requestAnimationFrame(update);
      }
    };

    update();
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
        entry.target.classList.add('animated');
        animateCounter(entry.target);
      }
    });
  }, { threshold: 0.6 });

  counters.forEach(counter => observer.observe(counter));
});
